module.exports = __webpack_public_path__ + "img/icon_map_hgt.852d59af.png";